import Breadcrumb from "@/components/layout/Breadcrumb";
import Header from "@/components/layout/Header";
import { AppSidebar } from "@/components/layout/Sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private")({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: "/login" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <div className="flex flex-1 flex-col min-w-0">
        <Header />
        <div className="container mx-auto flex flex-col min-h-[calc(100vh-4rem)] p-4 md:p-6">
          <Breadcrumb />
          <div className="flex-1 flex flex-col space-y-6">
            <Outlet />
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
}
